import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout.component';
import { RouterModule } from '@angular/router';
import { FuseProgressBarModule, FuseSidebarModule } from '@fuse/components';
import { NavbarModule } from './components/navbar/navbar.module';
import { ToolbarModule } from './components/toolbar/toolbar.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { HeaderModule } from './components/header/header.module';
import { MatTabsModule } from '@angular/material/tabs';
import { PageModule } from './components/pk-page-contents';

@NgModule({
  declarations: [LayoutComponent],
  imports: [
    RouterModule,
    FuseSharedModule,
    FuseSidebarModule,
    NavbarModule,
    ToolbarModule,
    HeaderModule,
    MatTabsModule,
    PageModule,
    FuseProgressBarModule
  ],
  exports: [LayoutComponent]
})
export class LayoutModule {
}
